import { makeStyles } from "tss-react/mui";

import { TxtColor, mobileBreakpoint, tabletBreakpoint } from "shared/theme/defaultTheme";

interface AuthWayStylesProps {
    showCatpcha: boolean;
}

export const useAuthWayStyles = makeStyles<AuthWayStylesProps>()((theme, { showCatpcha }) => ({
    radioControl: {
        marginBottom: showCatpcha ? theme.spacing(1.5) : theme.spacing(11),
        [theme.breakpoints.down(mobileBreakpoint)]: {
            marginBottom: showCatpcha ? theme.spacing(1.5) : theme.spacing(9),
        },
    },
    captchaContainer: {
        marginBottom: theme.spacing(1.5),
    },
    title: {
        marginBottom: theme.spacing(4),
    },
    buttonContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        [theme.breakpoints.down(tabletBreakpoint)]: {
            width: "100%",
        },
    },
    logInDescription: {
        textAlign: "center",
        marginBottom: theme.spacing(6),
        width: "100%",
        color: TxtColor.Txt2,
    },
}));
